<div class="login-page-container" fxLayout="row" fxLayoutAlign="center center">
  <app-splash-screen *ngIf="loading || user; else loginTemplate"></app-splash-screen>
  <ng-template #loginTemplate>
    <app-login-form fxFlex.xs="95" (actionHandler)="actionHandler($event)" [formLoading]="loading" [error]='error'></app-login-form>
  </ng-template>
</div>
